module.exports = __webpack_public_path__ + "static/img/bg_06.5de53ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_06.jpg
// module id = aDhj
// module chunks = 1